/* V-Supplies — comportamiento de header, menú móvil, reveal on scroll y cifras.
   Sin dependencias externas. Respeta prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader() {
    var header = document.querySelector('[data-vs-header]');
    if (!header) return;

    // Transparente sobre el hero -> sólido al hacer scroll (solo si es transparente)
    if (header.classList.contains('vs-header--transparent')) {
      var onScroll = function () {
        if (window.scrollY > 40) header.classList.add('vs-solid');
        else header.classList.remove('vs-solid');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Menú móvil
    var burger = header.querySelector('[data-vs-burger]');
    var mobile = header.querySelector('[data-vs-mobile-nav]');
    if (burger && mobile && !burger.dataset.vsBound) {
      burger.dataset.vsBound = '1';
      burger.addEventListener('click', function () {
        var open = mobile.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          header.classList.add('vs-solid');
        } else if (header.classList.contains('vs-header--transparent') && window.scrollY <= 40) {
          header.classList.remove('vs-solid');
        }
      });
      // Cerrar al pinchar un enlace
      mobile.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          mobile.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.vs-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function animateCount(el) {
    var raw = el.getAttribute('data-count');
    var num = parseFloat(raw);
    if (isNaN(num)) return;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduceMotion) { el.textContent = prefix + raw + suffix; return; }
    var dur = 1400, start = null;
    var isInt = raw.indexOf('.') === -1;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = num * eased;
      el.textContent = prefix + (isInt ? Math.round(val) : val.toFixed(1)) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + raw + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(animateCount);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initHeader();
    initReveal();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinicializar en el editor de temas de Shopify (al recargar secciones)
  document.addEventListener('shopify:section:load', init);
})();
